'use strict'

import $ from 'jquery'

export default class ProductBack {
  constructor() {
    $('.single-blog .back').click(function (e) {
      e.preventDefault()

      window.location = document.referrer + '#' + $('.single-blog .product-uid').attr('id')
    });

    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100)
      }
    }

    window.addEventListener("hashchange", offsetAnchor)

    window.setTimeout(offsetAnchor, 1)
  }
}
